import http from './index'

export default {
  install(Vue) {
    Vue.prototype.http = http
  }
}
